var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-option"},[_c('BaseRadioButtonNew',{attrs:{"value":_vm.value,"selected":_vm.selected,"padding-y":_vm.currentScreen === '1.4' && _vm.isMobile ? 18 : 20,"disabled":_vm.disabled},on:{"change":function($event){return _vm.$emit('change', _vm.value)}}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }